class Utils {
    static apiCall(data) {
        return fetch("/ChatAPI.cht", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
    }
    static displaySimpleMsg(dispatcher, content, onOk) {
        const handleOk = (e) => {
            dispatcher({ action: "closeOverlay", params: "msg" });
            if (onOk)
                onOk();
        };
        dispatcher({
            action: "openOverlay", params: {
                overlay: "msg", params: {
                    children: [
                        <div key="txt" className={"textContent"}>{content}</div>,
                        <div key="btns" className="dialog-buttons">
                            <button key="btn1" onClick={handleOk}>אישור</button>
                        </div>
                    ]
                }
            }
        });
    }

    static displaySimpleYNQuestion(dispatcher, { content, onYes, onNo, yesText, noText }) {
        const handleBtn = (action, e) => {
            dispatcher({ action: "closeOverlay", params: "msg" });
            if (action)
                action();
        };
        dispatcher({
            action: "openOverlay", params: {
                overlay: "msg", params: {
                    children: [
                        <div key="txt">{content}</div>,
                        <div key="btns" className="dialog-buttons">
                            <button key="btnNo" onClick={handleBtn.bind(this, onNo)}>{noText || "לא"}</button>
                            <button key="btnYes" onClick={handleBtn.bind(this, onYes)}>{yesText || "כן"}</button>
                        </div>
                    ]
                }
            }
        });
    }

    static ga_event(eventName, eventData) {
        try {
            if (window.gtag)
                window.gtag('event', eventName, eventData || {});
        } catch (ex) {
            console.error(ex);
        }
    }

    static formatDate(date) {
        if (!date) return "";
        let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
        let monthNum = date.getMonth() + 1;
        let month = monthNum < 10 ? "0" + monthNum : monthNum;

        try {
            date = new Date(date.getTime());
            return day + "." + month + "." + (date.getFullYear() - 2000);
        } catch (ignored) {
            return "";
        }
    };

    static dateObjToString(date) {
        if (!date) return "";

        let monthNum = date.getMonth() + 1;
        let month = monthNum < 10 ? "0" + monthNum : monthNum;
        let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();

        return "" + date.getFullYear() + month + day;
    }

    static dateStringToObj(dateString, def) {
        let res = def;

        try {
            if (dateString.length == 8)
                return new Date(
                    dateString.substring(0, 4) * 1,
                    dateString.substring(4, 6) * 1 - 1,
                    dateString.substring(6, 8) * 1
                );
            else
                throw Error("invalid date: " + dateString);
        } catch (ignored) { }

        return res;
    }
}

export { Utils }